<template>    
    <mainlist
        color="#fff"
        :items="adresses"
        :list="list"
    ></mainlist>
</template>
<script>
    import { mapGetters } from 'vuex';    
    import mainlist from '../components/lists/MainList.vue'; 
    export default {   
    
    props: [
        
    ],
    components:{
        mainlist: mainlist
    },
    data() {
        return {  
           list:"adresses"
                    
        }
    },
    computed: {
        ...mapGetters({            
            adresses: 'adresses/adresses'
        }),
        
    },
    methods: {
        
    },
    mounted() {
        this.$store.dispatch('adresses/getAll')
    }
    
    
}
</script>